import { StoreAction, XmAction } from 'store/actions';
import { ModelBase } from 'store/model-base';
import { Account, AllowedLines, User } from './models';

export function userReducer(state: User, action: XmAction<ModelBase>): User {
    let newState: User;
    switch (action.type) {
        case StoreAction.GET_ACCOUNT_INFO:
            newState = new User(state);
            newState.account = <Account> action.payload;

            return newState;
        case StoreAction.UPDATE_ACCOUNT_INFO:
            return <User> action.payload;
        case StoreAction.GET_ALLOWED_LINES:
            newState = new User(state);
            newState.allowedLines = <AllowedLines> action.payload;

            return newState;
        case StoreAction.CLEAR_ALLOWED_LINES:
            newState = new User(state);
            newState.allowedLines = undefined;

            return newState;
        default:
            return state;
    }
}
